import { OrderStatus } from 'contracts/Orders';
import styled, { css } from 'styled-components';
import {
  BasePaginatorHeader,
  BasePaginatorListItem,
  EyeIcon,
} from 'styles/components';
import { ColorScheme, Colors, Fonts, OrderStatusColor } from 'styles/constants';
import * as HoverCard from '@radix-ui/react-hover-card';
export {
  ActionButton,
  EditIcon,
  LinkActionButton,
  PaginatorActionsColumn as ActionsColumn,
  PaginatorColumn as Column,
  ChevronRightCircleIcon,
} from 'styles/components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderColumn = styled.div`
  display: flex;
  align-items: center;
  color: ${ColorScheme.Text};
  font-family: ${Fonts.GilroySemiBold};
  font-size: 11px;
`;

const baseGridCss = css`
  grid-template-columns: 64px // order number
    100px // order type
    100px // status
    50px // items count
    100px // scheduledAt
    160px // scheduled dock
    100px // area
    190px // physical dock
    70px // weight
    110px // value
    120px // vehicle type
    70px // vehicle plate
    280px // company
    280px // carrier
    auto // created by and at
    minmax(0px, max-content); // actions

  @media screen and (max-width: 1880px) {
    grid-template-columns: 64px // order number
      100px // order type
      100px // status
      100px // scheduledAt
      160px // scheduled dock
      100px // area
      190px // physical dock
      120px // vehicle type
      70px // vehicle plate
      180px // company
      180px // carrier
      auto // created by and at
      minmax(0px, max-content); // actions
    > div:nth-child(4),
    > div:nth-child(9),
    > div:nth-child(10) {
      display: none;
    }
  }

  @media screen and (max-width: 1500px) {
    grid-template-columns: 64px // order number
      100px // order type
      100px // status
      100px // scheduledAt
      160px // scheduled dock
      100px // area
      190px // physical dock
      180px // company
      180px // carrier
      auto // created by and at
      minmax(0px, max-content); // actions
    > div:nth-child(11),
    > div:nth-child(12) {
      display: none;
    }
  }
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${baseGridCss}
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${baseGridCss}
`;

// Status Label

const applyStatusColor = (status?: OrderStatus) => {
  switch (status) {
    case 'aguardando':
      return css`
        background-color: ${OrderStatusColor.Aguardando};
      `;
    case 'chegada':
      return css`
        background-color: ${OrderStatusColor.Chegada};
      `;
    case 'iniciado':
      return css`
        background-color: ${OrderStatusColor.Iniciado};
      `;
    case 'finalizado':
      return css`
        background-color: ${OrderStatusColor.Finalizado};
      `;
    case 'liberado':
      return css`
        background-color: ${OrderStatusColor.Liberado};
      `;
    case 'noShow':
      return css`
        background-color: ${OrderStatusColor.NoShow};
      `;
    case 'cancelado':
      return css`
        background-color: ${OrderStatusColor.Cancelado};
      `;
    case 'atrasado':
      return css`
        background-color: ${OrderStatusColor.Atrasado};
      `;
    default:
      return css``;
  }
};

interface IStatusLabel {
  status?: OrderStatus;
}

export const StatusLabel = styled.label<IStatusLabel>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100%;
  padding: 4px 8px;
  font-family: ${Fonts.GilroyBold};
  font-size: 12px;
  border-radius: 4px;
  color: ${Colors.White};
  background-color: ${Colors.Blue};
  ${({ status }) => applyStatusColor(status)}
`;

export const Eye = styled(EyeIcon)`
  color: ${Colors.Gray50};
  width: 20px;
  height: 20px;
  position: relative;
  top: 2px;
`;

export const HoverCardArrow = styled(HoverCard.Arrow)`
  fill: ${Colors.Gray70};
`;

export const HoverCardContent = styled(HoverCard.Content)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 6px;
  background: ${Colors.Gray70};
  width: 100%;
  max-width: 400px;
  z-index: 1;

  p {
    font-family: ${Fonts.GilroySemiBold};
    font-size: 14px;
    color: ${Colors.Gray10};
  }
`;

export const GhostColumn = styled.div`
  width: 32px;
`;
